export default {"src":"/_next/static/media/twitter_icon.5abbe55b.svg","height":32,"width":40,"blurWidth":0,"blurHeight":0};